<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                <show-field :value="item.marca.nombre" :label="$t('producto.labels.marca')" icon="show-sneaker" />
                <show-field :value="item.modelo.nombre" :label="$t('producto.labels.modelo')" icon="" />
                <show-field :value="(item.tamanio && item.tamanio.tamanio) ? item.tamanio.tamanio : '-'" :label="$t('producto.labels.tamanio')" icon="" />
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                <show-field :value="item.codigoBarras" :label="$t('producto.labels.codigoBarras')" icon="" />
                <show-field :value="(item.productoProveedorPrecioActivo && item.productoProveedorPrecioActivo.codigoBarrasProveedor) || item.codigoBarrasProveedor || '-'" :label="$t('producto.labels.codigoBarrasProveedor')" icon="" />
                <show-field :value="item.otrasCaracteristicas || '-'" :label="$t('producto.labels.otrasCaracteristicas')" icon="" />
                <show-field :value="item.precio ? item.precio.toFixed(2) : '0.00'" :label="$t('producto.labels.precioVenta')" icon="" />
                <show-field :value="(item.productoProveedorPrecioActivo && item.productoProveedorPrecioActivo.precioCompra != null) ? item.productoProveedorPrecioActivo.precioCompra.toFixed(2) : (item.precioCompra ? item.precioCompra.toFixed(2) : '-')" :label="$t('producto.labels.precioCompra')" icon="" />
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                <show-field :value="String(item.stock)" :label="$t('producto.labels.stock')" icon="" />
                <show-field :value="String(item.stockAlerta)" :label="$t('producto.labels.stockAlerta')" icon="" />
                <show-field :value="item.fechaVencimiento ? getDateTimeFormat(item.fechaVencimiento) : '-'" :label="$t('producto.labels.fechaVencimiento')" icon="" />
                <show-field :value="item.creadoPor.username" :label="$t('producto.labels.creadoPor')" icon="" />
            </v-list>
        </v-col>

    </v-row>
</template>
<script>
import { ShowField } from '@dracul/common-frontend'
import { DayjsMixin } from "@dracul/dayjs-frontend";

export default {
    name: 'ProductoShowData',
    components: { ShowField },
    mixins: [DayjsMixin],
    props: {
        item: { type: Object, required: true }
    }
}
</script>
